module.exports = __webpack_public_path__ + "img/googleslide-addin-04.a4e3d181.png";